import { Component, OnInit, ViewEncapsulation, Input, Output, ChangeDetectorRef, EventEmitter, Inject } from '@angular/core';
import { PanicRoleService } from '../../../services/PanicRole.service';
import { IErrorHandlerToken, IErrorHandler } from '../../../dataModels';


@Component({
    selector: 'resolve-panic',
    templateUrl: './resolve-panic.component.html',

})
export class ResolvePanicComponent implements OnInit {

    isResolver: boolean = true;

    reason: string;
    resolvingWay: string;

    @Input() alertData: any;

    @Output() resolveForm: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private panicRoleService: PanicRoleService, private ref: ChangeDetectorRef,
        @Inject(IErrorHandlerToken) private _errorHandler: IErrorHandler) { }

    ngOnInit() { }

    closeSolvingForm() {
        this.resolveForm.emit(false);
    }

    resolvePanic() {
        this.alertData.ResolveReason = this.reason;
        this.alertData.ResolvingWay = this.resolvingWay;

        this.panicRoleService.ResolvePanic(this.alertData).subscribe(res => {
            if (res.IsErrorState) {
                this._errorHandler.DefaultError();
            }
        });
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/PanicAlert/resolve-panic/resolve-panic.component.ts